import { VitalSourceEvents } from 'Lib/constants.js';

import store from '../configureStore';


function VitalSourceEventHandler(vsEvent) {
  let handleEvent = {};

  handleEvent['page:scroll'] = (e, data) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:navigationRequested'] = (e, data) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:pagebreak'] = (e, data) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:touchstart'] = (e, data) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:touchend'] = (e, data) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:touchmove'] = (e, data) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['snippet:ready'] = (e, data) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['page:load'] = (e, data) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:selectionMade'] = (e, data) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:selectionWithPosition'] = (e, data) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['highlight:click'] = (e, data) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:click'] = () => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent]
    });
  };

  handleEvent['noteicon:click'] = (e, data) => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent],
      data
    });
  };

  handleEvent['book:selectionCancelled'] = () => {
    store.dispatch({
      type: VitalSourceEvents[vsEvent]
    });
  };

  return handleEvent[vsEvent];
}

function* bindAndHandleEvents() {
  for (const vsEvent of Object.keys(VitalSourceEvents)) {
    window.vsViewer.bind(vsEvent, VitalSourceEventHandler(vsEvent));
  }
}


export default bindAndHandleEvents;
